var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 153,
    viewBox: "0 0 168 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.9998 152.917L71.9165 141.917C28.9998 103 0.666504 77.3333 0.666504 45.8333C0.666504 20.1667 20.8332 0 46.4998 0C60.9998 0 74.9165 6.75 83.9998 17.4167C93.0832 6.75 107 0 121.5 0C147.167 0 167.333 20.1667 167.333 45.8333C167.333 77.3333 139 103 96.0832 142L83.9998 152.917Z",
    fill: "#0054A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueheart);
export default __webpack_public_path__ + "static/media/blueheart.71ea1e3387d720cedb65832640ded0f2.svg";
export { ForwardRef as ReactComponent };